import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { setCampaign } from 'common/utils/partnerCampaign';

/*
 * Each partner's Adjust link (Campaign Lab > Custom links). A phone that opens
 * https://app.doqit.io/partner/<slug> in a browser does not have the app (with
 * the app installed, iOS opens it straight from the universal link), so it is
 * sent on to the Adjust link: Android opens the app or the Play Store, iPhone
 * goes to the App Store, both with the install attributed to the partner and the
 * partner deep link carried through the install. Desktop stays on the web.
 */
const PARTNER_ADJUST_LINKS: Record<string, string> = {
  nameswitch: 'https://app.adjust.com/266csudo?deep_link=doqit%3A%2F%2Fpartner%2Fnameswitch'
    + '&fallback=https%3A%2F%2Fapp.doqit.io%2Fpartner%2Fnameswitch'
    + '&redirect_macos=https%3A%2F%2Fapp.doqit.io%2Fpartner%2Fnameswitch',
};

const isPhoneBrowser = (): boolean => !Capacitor.isNativePlatform()
  && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent || '');

/**
 * https://app.doqit.io/partner/<slug> opened in a browser: remember the partner
 * tag, then send phones on to the store via the partner's Adjust link, or carry
 * on to the normal start on desktop. The paywall reads the tag and RevenueCat
 * shows that partner's offering. In the app the same link is handled by
 * AppLifecycleHandler and never routes here.
 */
const PartnerLink: React.FC = () => {
  const { slug } = useParams();
  const [done, setDone] = useState(false);
  useEffect(() => {
    const campaign = setCampaign(slug, 'web_link');
    const adjust = campaign ? PARTNER_ADJUST_LINKS[campaign] : undefined;
    if (adjust && isPhoneBrowser()) {
      window.location.replace(adjust);
      return;
    }
    setDone(true);
  }, [slug]);
  return done ? <Navigate to="/" replace /> : null;
};

export default PartnerLink;
